module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-fullwidth login-button-primary",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "disabled": _vm.disabled,
      "href": _vm.href
    },
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64c1c658", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64c1c658!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/ButtonPrimary.vue
// module id = 858
// module chunks = 0